export default __webpack_public_path__ + "static/media/BeachNew.ba419813.jpg";